module.exports = __webpack_public_path__ + "static/media/positioning-top-left_24.3f06ac0a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/positioning-top-left_24.svg
// module id = 891
// module chunks = 0